<template>
  <div class="container" style="padding-bottom: 25px">
    <h3 class="title">一.账号登录</h3>
    <p class="text">
      1.请登录管理员账号，方便随时查看打印明细
    </p>
    <PreViewImage
      class="b3-1 commonImg mr50 mrb70"
      :src="require('../../../assets/img/guide/b3-1.png')"
    />
    <h3 class="title">二.查看打印明细</h3>
    <h4 class="subTitle bold" style="margin-bottom: 4px">
      2.1福昕智慧打印小程序查看
    </h4>
    <p class="text">
      路径：首页-》设备-》打印记录;
    </p>
    <div class="imgComtainer">
      <div style="margin-right: 54px">
        <PreViewImage
          class="b3-2 commonImg mr50 mrb70"
          :src="require('../../../assets/img/guide/b3-2.png')"
        />
      </div>
      <div>
        <PreViewImage
          class="b3-3 commonImg mr50 mrb70"
          :src="require('../../../assets/img/guide/b3-3.png')"
        />
      </div>
    </div>
    <h4 class="subTitle bold" style="margin-bottom: 4px">
      2.2福昕云办公工作台查看
    </h4>
    <p class="text">
      路径：云办公首页-》我的工作台-》智慧打印-》打印记录;
    </p>
    <p class="text">
      网址：<a class="hrefA" href="https://www.foxitcloud.cn/work/printRecords"
        >https://www.foxitcloud.cn/work/printRecords</a
      >
    </p>
    <PreViewImage
      class="b3-4 commonImg mr40"
      :src="require('../../../assets/img/guide/b3-4.png')"
    />
    <PreViewImage
      class="b3-5 commonImg mr50 mrb70"
      :src="require('../../../assets/img/guide/b3-5.png')"
    />
  </div>
</template>

<script>
import PreViewImage from "common/components/app/PreViewImage.vue";

export default {
  components: {
    PreViewImage
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/guide.scss";

.b3-1 {
  width: 371px;
}

.b3-4,
.b3-5 {
  width: 554px;
}

.imgComtainer {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  img {
    width: 207px;
  }
}
</style>
